import moment from "moment";

export function getFriendlyDateFormat(date) {
    const isMoreThan1Day = moment().diff(moment(date), "days") >= 1;
    const value = isMoreThan1Day ? moment(date).format("MM.DD.YYYY hh:mm A") : moment(date).fromNow();
    return value;
}

export function getFriendlyDateFormatWithUtcTime(date) {
    const isMoreThan1Day = moment.utc().diff(moment.utc(date), "days") >= 1;
    const value = isMoreThan1Day ? moment.utc(date).format("MM.DD.YYYY hh:mm A") : moment.utc(date).fromNow();
    return value;
}

export function getFriendlyDateFormatWithoutTime(date) {
    const isMoreThan1Day = moment().diff(moment(date), "days") >= 1;
    const value = isMoreThan1Day ? moment(date).format("MM.DD.YYYY") : moment(date).fromNow();
    return value;
}

export function getMonthDiff(date) {
    return moment(date).diff(moment(), "months");
}
